export class ActionFormData {
  emailAddress: string | undefined;
  includeDescriptionFields: boolean | undefined;
  subjectTag: string | undefined;
  url: string | undefined;
  token: string | undefined;
  bearer: string | undefined;
  service: string | undefined;
  queue: string | undefined;
  type: string | undefined;
  title: string | undefined;
  dynamicFields: string | undefined;

  constructor(stringToParse: string | undefined) {
    this.emailAddress = '';
    this.includeDescriptionFields = false;
    this.subjectTag = '';
    this.url = '';
    this.token = '';
    this.bearer = '';
    this.service = '';
    this.queue = '';
    this.type = '';
    this.title = '';
    this.dynamicFields = '';
    if (stringToParse) {
      const parsed = JSON.parse(stringToParse);
      if (parsed) {
        this.emailAddress = parsed.emailAddress;
        this.includeDescriptionFields = parsed.includeDescriptionFields;
        this.subjectTag = parsed.subjectTag;
        this.url = parsed.url;
        this.token = parsed.token;
        this.bearer = parsed.bearer;
        this.service = parsed.service;
        this.queue = parsed.queue;
        this.type = parsed.type;
        this.title = parsed.title;
        this.dynamicFields = parsed.dynamicFields;
      }
    }
  }
}
